module.exports = __webpack_public_path__ + "static/media/elife-school-2024-2.f157bb14.gif";